import { Reactions } from '@/domain/entities/Comment';
import { sumReactions } from '@/presentation/components/ReactionsModal';

export const getTotalCommentReactionsFromUser = (reactions: Reactions) =>
  sumReactions(reactions);
